module.exports = __webpack_public_path__ + "static/media/selfie-image.b1b880fc.png";